import { ReactNode, useMemo, useState } from "react";
// MUI
import { Box, Stack } from "@mui/material";

// Components
import FilterButton from "@Layouts/components/FloatingTabButtonSelector/FilterButton.tsx";

type FloatingTab = {
	label: string;
	isDisabled: boolean;
	selected: boolean;
};
// Types
type FloatingTabButtonsProps = {
	filterOptions: string[];
	contents: ReactNode[];
	initialTab?: number;
	selectedTab?: string;
	// Styles
	spacing?: number;
	// Callbacks
	onToggleSelected: (label: string) => void;
	onChangeTab?: (index: number) => void;
	renderTab?: (tab: FloatingTab, index: number) => ReactNode;
};
export default function FloatingTabButtonSelector(props: FloatingTabButtonsProps) {
	const { filterOptions, selectedTab, initialTab, contents, spacing = 3, onToggleSelected, renderTab, onChangeTab } = props;

	const [activeTab, setActiveTab] = useState(initialTab ?? 0);

	const handleTabClick = (index: number) => {
		setActiveTab(index);
		onChangeTab?.(index);
	};

	const optionTabs = useMemo<FloatingTab[]>(() => {
		return filterOptions.map((filter) => {
			return {
				label: filter,
				isDisabled: false,
				selected: selectedTab === filter,
			};
		});
	}, [filterOptions, selectedTab]);

	return (
		<Stack spacing={spacing} alignItems={"center"} component={"menu"} role={"menubar"}>
			{/* Render Tabs */}
			<Stack direction={"row"} spacing={2}>
				{optionTabs.map((tab, idx) => {
					if (renderTab) {
						return (
							<Box key={idx} onClick={() => !tab.isDisabled && handleTabClick(idx)}>
								{renderTab(tab, idx)}
							</Box>
						);
					}
					return (
						<FilterButton
							key={tab.label}
							{...tab}
							onToggleSelected={() => {
								onToggleSelected(tab.label);
							}}
						/>
					);
				})}
			</Stack>
			{/* Tab Content */}
			<Box>{contents[activeTab]}</Box>
		</Stack>
	);
}
